import React, { useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import EQuoteAgentDetailsBanner from '../agent/EQuoteAgentDetailsBanner'
import { updateCurrentAppStep } from '../../actions/appState'
import { getBrandClassName } from '../../reducers/packageDetails'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'
import { resetActivePackage } from '../../actions/activePackage'
import '../../styles/scss/components/equote-header.scss'
import eQuoteLogo from '../../assets/icons/equote-logo.svg'
import { getSingleBrandDetails } from '../../reducers/brands'

function hasImage(currentBrand) {
  return (
    currentBrand &&
    currentBrand.badge_light &&
    currentBrand.badge_light.sizes &&
    currentBrand.badge_light.sizes['agency-logo']
  )
}

const EQuoteHeader = props => {
  const { agency, goToNextStep, currentStep, goBackToDetails } = props

  const [isAgentDetailOpened, setAgentDetailOpened] = useState(true)
  const agentDetailBannerRef = useRef()
  const returnDetailsButtonRef = useRef()

  const handleShowAgentDetail = () => {
    agentDetailBannerRef.current.classList.toggle('show')
    setAgentDetailOpened(!isAgentDetailOpened)
  }

  useEffect(() => {
    currentStep === 0 &&
      returnDetailsButtonRef.current &&
      returnDetailsButtonRef.current.classList.add('u-display-none')
    currentStep === 1 &&
      returnDetailsButtonRef.current &&
      returnDetailsButtonRef.current.classList.remove('u-display-none')
  }, [currentStep])
  if (
    props.errorStatus &&
    (props.errorStatus === 404 || props.errorStatus === 'deprecated')
  ) {
    return null
  }

  if (props.errorStatus && props.errorStatus === 404) {
    return null
  }

  return (
    <div>
      <div className="equote-header">
        <div className="u-content-container u-flex-container--center equote-header--inner">
          {agency && agency.logo && agency.logo['agency-logo'] && (
            <div className="equote-header--agent-logo-container">
              <img
                onClick={handleShowAgentDetail}
                className={`equote-header--agent-logo ${
                  isAgentDetailOpened ? 'show' : ''
                }`}
                src={agency.logo['agency-logo']}
                alt="eQuote"
              />
            </div>
          )}

          <div className="equote-header--equote-logo-container">
            <img alt="equote-logo" src={eQuoteLogo} />
          </div>
          <div className="equote-header--brand-logo-container">
            {hasImage(props.brandDetails) && (
              <img
                src={props.brandDetails.badge_light.sizes['agency-logo']}
                alt={props.brandDetails.badge_light.alt}
              />
            )}
          </div>
        </div>
      </div>
      {agency && (
        <EQuoteAgentDetailsBanner {...props} ref={agentDetailBannerRef} />
      )}

      {/* Button that return to details page on Mobile */}
      {!isAgentDetailOpened && (
        <button
          ref={returnDetailsButtonRef}
          id="returnDetailsButton"
          className="btn btn-white u-uppercase u-margin-auto"
          onClick={() => {
            if (!currentStep) {
              triggerCustomGaEvent('sailingPreview-requestSailing', true)
              goToNextStep(currentStep)
            } else {
              triggerCustomGaEvent('requestSailing-returnToDetails', true)
              goBackToDetails()
            }
          }}
        >
          {currentStep ? 'Return to Details' : 'Request This Sailing'}
        </button>
      )}
    </div>
  )
}

const mapStateToProps = state => {
  const brandDetails = getSingleBrandDetails(state)

  return {
    agency: state.agencyDetails.agency,
    brandDetails,
    agent: state.agencyDetails.agent,
    brandClassName: getBrandClassName(state),
    currentStep: state.appState.currentStep
  }
}

const mapDispatchToProps = dispatch => ({
  goToNextStep(currentStep) {
    dispatch(updateCurrentAppStep(currentStep + 1))
  },
  goBackToDetails() {
    dispatch(updateCurrentAppStep(0))
    dispatch(resetActivePackage())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EQuoteHeader)
